import React from 'react';
import PropTypes from 'prop-types';

class DynamicFormFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      objects: props.objects,
    };

    this.addObject = this.addObject.bind(this);
    this.makePrimary = this.makePrimary.bind(this);
    this.handleInfoInputChange = this.handleInfoInputChange.bind(this);
    this.autoAddField = this.autoAddField.bind(this);
    this.refreshPrimary = this.refreshPrimary.bind(this);
    this.delete = this.delete.bind(this);
    this.destroyField = this.destroyField.bind(this);
    this.inputField = this.inputField.bind(this);
    this.fieldList = this.fieldList.bind(this);
  }

  componentDidMount() {
    this.autoAddField();
    this.refreshPrimary();
  }

  handleInfoInputChange(e, changedInfo) {
    const { contactInfos } = this.state;
    const newInfos = contactInfos.map((info) => {
      if (info === changedInfo) {
        // eslint-disable-next-line no-param-reassign
        _.extend(info, { value: e.target.value });
        return info;
      }

      return info;
    });

    this.setState({ contactInfos: newInfos }, this.autoAddField);
  }

  makePrimary(toBePrimary) {
    const { contactInfos } = this.state;
    const updatedInfos = contactInfos.map((info) => {
      if (info.primary) {
        // eslint-disable-next-line no-param-reassign
        info.primary = false;
      }

      if (info === toBePrimary) {
        // eslint-disable-next-line no-param-reassign
        info.primary = true;
      }

      return info;
    });

    this.setState({ contactInfos: updatedInfos });
  }

  addObject() {
    const { objects } = this.state;
    objects.push({ __private_id: Date.now() });
    this.setState({ objects });
  }

  autoAddField() {
    // eslint-disable-next-line react/destructuring-assignment
    const emptyInfos = this.state.contactInfos.filter((info) => !info.value);

    if (emptyInfos.length === 0) {
      this.addContactInfo();
    }
  }

  refreshPrimary() {
    const { contactInfos } = this.state;
    const primaryInfo = contactInfos.filter((info) => info.primary && !info._destroy);

    if (primaryInfo.length === 0) {
      this.makePrimary(contactInfos.filter((info) => !info._destroy)[0]);
    }
  }

  delete(toBeDeleted) {
    let updatedInfos = [];
    const { contactInfos } = this.state;

    if (toBeDeleted.id) {
      updatedInfos = contactInfos.map((info) => {
        if (info === toBeDeleted) {
          // eslint-disable-next-line no-param-reassign
          info._destroy = true;
        }

        return info;
      });
    } else {
      updatedInfos = contactInfos.filter((info) => info !== toBeDeleted);
    }

    this.setState({ contactInfos: updatedInfos }, this.refreshPrimary);
  }

  destroyField(info) {
    const { form_for: formFor, fields_for: fieldsFor } = this.props;

    return (
      <div key={info.id || info.__private_id}>
        <input
          type="hidden"
          value={info.value}
          name={`${formFor}[${fieldsFor}_attributes][][string]`}
        />
        <input
          type="hidden"
          name={`${formFor}[${fieldsFor}_attributes][][_destroy]`}
          value
        />
        <input
          type="hidden"
          name={`${formFor}[${fieldsFor}_attributes][][id]`}
          value={info.id}
        />
      </div>
    );
  }

  inputField(info, i) {
    const {
      form_for: formFor,
      fields_for: fieldsFor,
      field_class: fieldClass,
      info_type: infoType,
    } = this.props;

    return (
      <div key={info.id || info.__private_id}>
        <input
          className={fieldClass}
          type="text"
          defaultValue={info.value}
          name={`${formFor}[${fieldsFor}_attributes][][string]`}
          onChange={(e) => this.handleInfoInputChange(e, info)}
          id={`contact-info-field-${infoType}-${i}`}
        />
        <input
          type="hidden"
          name={`${formFor}[${fieldsFor}_attributes][][info_type]`}
          value={infoType}
        />
        <input
          type="hidden"
          name={`${formFor}[${fieldsFor}_attributes][][primary]`}
          value={!!info.primary}
        />
        <input
          type="hidden"
          name={`${formFor}[${fieldsFor}_attributes][][id]`}
          value={info.id}
        />
      </div>
    );
  }

  fieldList() {
    const that = this;
    const { contactInfos } = this.state;

    return contactInfos.map((info, i) => {
      let primaryButton;

      if (info.primary) {
        primaryButton = <div className="d-grid"><span className="btn btn-success">Primary</span></div>;
      } else {
        primaryButton = (
          <div className="d-grid">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => that.makePrimary(info)}
            >Make Primary
            </button>
          </div>
        );
      }

      const deleteButton = (
        <div className="d-grid">
          <button
            type="button"
            className="btn btn-confirm btn-outline-danger"
            onClick={() => that.delete(info)}
          >
            <i className="fa-solid fa-trash-can" />
          </button>
        </div>
      );

      let fieldList;

      if (info._destroy) {
        fieldList = that.destroyField(info, i);
      } else {
        fieldList = (
          <div
            key={info.id || info.__private_id}
            className="row mt-1"
          >
            <div className="col-md-7">
              {that.inputField(info, i)}
            </div>
            {(info.primary || !!info.value)
              && (
                <div className="col-md-3">
                  {primaryButton}
                </div>
              )}
            {!!info.value && contactInfos.filter((inf) => !inf._destroy).length > 1
              && (
                <div className="col-md-2">
                  {deleteButton}
                </div>
              )}
          </div>
        );
      }

      return fieldList;
    });
  }

  render() {
    return (
      <div>
        {this.fieldList()}
      </div>
    );
  }
}

DynamicFormFields.propTypes = {
  objects: PropTypes.arrayOf(Object).isRequired,
  form_for: PropTypes.string,
  fields_for: PropTypes.string,
  field_class: PropTypes.string,
  info_type: PropTypes.string,
};

DynamicFormFields.defaultProps = {
  form_for: undefined,
  fields_for: undefined,
  field_class: undefined,
  info_type: undefined,
};

export default DynamicFormFields;
